import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const ShipsCodebookRepository = {
  getShips: () => {
    return Axios({
      url: `${SETTINGS.API_URL}shipsCodebook/all`,
      method: "GET",
    });
  },

  getAllByCustomsOfficeId: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}shipsCodebook/allByOOFEid/${id}`,
      method: "GET",
    });
  },
};
